import { Button, Card, CardHeader, CardHeaderActions, CardHeading, ConfirmationDialog, Id } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { companyService } from "../../shared/api/companyService";
import { TenantArchiveDrawer } from "../../shared/tenantArchive/TenantArchiveDrawer";
import { useRestoreByTenantHandler } from "../../shared/tenantArchive/useRestoreByTenantHandler";

interface Props {
	id: Id;
	className?: string;
}

const WarningCard = styled(Card)`
	background-color: ${({ theme }) => theme.colors.palette.warning.light.base};
`;

export const ArchivedCompanyBanner: FC<Props> = ({ id, className }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const {
		clickHandler: restoreClickHandler,
		drawerProps,
		confirmationProps,
	} = useRestoreByTenantHandler(companyService, () => navigate(`../../../active/${id}`, { replace: true }));

	return (
		<WarningCard className={className}>
			<CardHeader>
				<CardHeading>{t("This company is archived in at least this tenant")}</CardHeading>
				<CardHeaderActions>
					<Button onClick={() => restoreClickHandler(id)} title={t("Restore")} size="small">
						{t("Restore")}
					</Button>
					<TenantArchiveDrawer {...drawerProps} title={t("Restore")} type="restore" service={companyService} />
					<ConfirmationDialog
						{...confirmationProps}
						heading={t("Restore")}
						labels={{ close: t("Close"), confirm: t("Confirm") }}
					>
						{t("Are you sure you want to restore this company?")}
					</ConfirmationDialog>
				</CardHeaderActions>
			</CardHeader>
		</WarningCard>
	);
};
